// extracted by mini-css-extract-plugin
export default {"breakpointXs":"375px","breakpointSm":"544px","breakpointMd":"768px","breakpointLg":"1024px","breakpointXl":"1200px","breakpointXxl":"1600px","mainContainer":"NpiB5Xm5k2Hr0oVPyDMs"};